module.exports = __webpack_public_path__ + "img/speed-1.aea0e285.png";